import strings from '../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.datasheet.name.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'lengthMin',
      conf: {
        min: 1
      },
      invalidFeedback: strings.form.datasheet.name.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

export const form = {
  formKey: "datasheet",
  fields: [
    name,
  ]
}
